import React from 'react';

export const EditLessonSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="683"
    height="682"
    viewBox="0 0 683 682"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M540.443 341.647C524.714 341.647 512 354.392 512 370.09V597.647C512 613.319 499.255 626.09 483.557 626.09H85.3333C69.6302 626.09 56.8906 613.319 56.8906 597.647V199.423C56.8906 183.751 69.6302 170.98 85.3333 170.98H312.891C328.62 170.98 341.333 158.236 341.333 142.538C341.333 126.835 328.62 114.09 312.891 114.09H85.3333C38.2865 114.09 0 152.376 0 199.423V597.647C0 644.694 38.2865 682.98 85.3333 682.98H483.557C530.604 682.98 568.891 644.694 568.891 597.647V370.09C568.891 354.361 556.172 341.647 540.443 341.647Z"
      fill="currentColor"
    />
    <path
      d="M266.693 315.736C264.703 317.725 263.365 320.257 262.797 322.986L242.687 423.569C241.75 428.23 243.229 433.038 246.583 436.423C249.286 439.126 252.927 440.574 256.656 440.574C257.562 440.574 258.505 440.491 259.443 440.293L359.995 420.184C362.781 419.611 365.313 418.277 367.276 416.283L592.328 191.23L491.776 90.6836L266.693 315.736Z"
      fill="currentColor"
    />
    <path
      d="M661.844 21.1367C634.115 -6.59766 589 -6.59766 561.292 21.1367L521.927 60.5013L622.479 161.053L661.844 121.684C675.271 108.288 682.667 90.4232 682.667 71.4232C682.667 52.4232 675.271 34.5586 661.844 21.1367Z"
      fill="currentColor"
    />
  </svg>
);

export default EditLessonSvg;
